<div class="menu">
  <div class="menu__label">
    <ng-content select="[menu-label]"></ng-content>
  </div>
  <div class="menu__content" [ngClass]="{ 'open': isVisible }" >
    <ul class="menu__list">
      <li class="menu__item"
          *ngFor="let item of items"
          (click)="item.command && item.command(); isVisible = false"
      >
        {{ item.label }}
      </li>
    </ul>
  </div>
</div>
